'use client';
import React from 'react';
import { Button, Chip, Div, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import routes from '@routes';
import BackgroundImage from '../sub-component/background-image';
import getParseRoute from '@utils/helpers/parse-route';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';

const imageSize = {
  Mobile: {
    height: '195px',
    width: '198px',
  },
  MobileHor: {
    height: '245px',
    width: '253px',
  },
  Tablet: {
    width: '320px',
    height: '310px',
  },
  TabletHor: {
    width: '387px',
    height: '374px',
  },
  HD: {
    width: '387px',
    height: '374px',
  },
  MidHD: {
    width: '671px',
    height: '650px',
  },
  FullHD: {
    width: '580px',
    height: '550px',
  },
};

const LaboratorySection = ({ translate }: {translate: any}) => {
  const { lang } = useParams<{ lang: LocaleTypes }>();

  return (
    <Div className={'w-full flex-col sm:flex-row items-end justify-end md:justify-between gap-x-4'}>
      <BackgroundImage imageSize={imageSize}>
        <Image
          className={'object-contain'}
          alt={'image'}
          src={'/images/home-screen/background-svg/nurse-2.png'}
          sizes={'(max-width: 639px) 25vw, (max-width: 1023px) 33vw, 50vw'}/>
      </BackgroundImage>
      <Div className={'self-start items-start flex-col w-full sm:w-3/5 md:w-1/2 sm:mt-12 md:my-16'}>
        <Div className={'flex-col self-center items-center px-2 gap-y-2'}>
          <Text className={'self-start'} color={'grey.900'} typography={'xl'} type={'bold'}>{translate.title}</Text>
          <Text className={'self-start'} align={'start'} color={'tertiary'} typography={'lg'} type={'medium'}>{translate.sub_title}</Text>
          <Div className={'justify-center'}>
            <Text className={'text-justify'} color={'grey.500'} typography={'base'}>{translate.description}</Text>
          </Div>
        </Div>
        <Div className={'items-center mt-14 gap-4'}>
          <Button disabled={true} href={getParseRoute({ pathname: routes['route.labs.index'], locale: lang })} className={'w-full sm:w-96 z-[4]'}>
            {translate.buttons.laboratory_index}
          </Button>
          <Chip color={'danger'} value={translate.coming_soon} />
        </Div>
      </Div>
    </Div>
  );
};

export default LaboratorySection;
